export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            移动端体验
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            随时随地畅享99视频聚合平台的精彩内容，手机观影同样流畅高清
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
              <div className="absolute bottom-0 left-0 w-80 h-80 bg-white rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
            </div>

            <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              <div className="flex-1 text-center lg:text-left">
                <span className="inline-block px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium mb-4 border border-white/15">
                  99视频移动版
                </span>
                <h3 className="text-2xl md:text-3xl font-bold text-white font-heading mb-4">
                  口袋里的影视聚合平台
                </h3>
                <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6">
                  99视频移动版完美适配手机屏幕，聚合香蕉视频、红桃视频、91视频、蜜桃视频全部资源。流畅播放不卡顿，随时随地追剧看片。支持收藏、历史记录、清晰度切换等实用功能，让移动观影体验更上一层楼。
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-white/15 rounded-xl border border-white/20 cursor-pointer hover:bg-white/25 transition-colors">
                    <i className="ri-android-line text-white text-lg"></i>
                    <span className="text-white text-sm font-medium whitespace-nowrap">Android 下载</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-white/15 rounded-xl border border-white/20 cursor-pointer hover:bg-white/25 transition-colors">
                    <i className="ri-apple-line text-white text-lg"></i>
                    <span className="text-white text-sm font-medium whitespace-nowrap">iOS 下载</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-white/15 rounded-xl border border-white/20 cursor-pointer hover:bg-white/25 transition-colors">
                    <i className="ri-qr-code-line text-white text-lg"></i>
                    <span className="text-white text-sm font-medium whitespace-nowrap">扫码体验</span>
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 w-56 md:w-64">
                <div className="relative">
                  <div className="absolute -inset-2 bg-white/10 rounded-[2.5rem] blur-xl"></div>
                  <div className="relative rounded-[2rem] overflow-hidden border-4 border-white/20 shadow-2xl">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20screen%20mockup%20showing%20video%20streaming%20interface%20with%20warm%20coral%20and%20dark%20theme%2C%20movie%20thumbnails%20grid%20layout%2C%20clean%20UI%20design%2C%20elegant%20dark%20background%20with%20warm%20accent%20highlights%2C%20premium%20app%20aesthetic%2C%20no%20text&width=500&height=900&seq=app-mobile-screen&orientation=portrait"
                      alt="99视频移动端界面展示"
                      className="w-full h-auto object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}